import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface LaundryIssuedParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface LaundryIssued {
    id?: any;
    tenantId: any;
    branchId: any;
    receiverType:string;
    receiverId:any;
    issueDate:Date;
    notes?:string;
    issuedBy?:any;
    status:string;

    parameters?: LaundryIssuedParameter[];
    links?: any;
}
export interface QuickList{
  // id:any;
  laundryIssuedId:any;
  // name:string;
  // count:number;
  total:number;
}
export interface FrontList{
  id:any;
  issuer:string;
  receiver:string,
  issueDate:Date;
  //receivedBy:string;
  status:string;
}

export interface LaundryIssuedDetail{
   // [x: string]: any;
    id?:any;
    tenantId:any;
    branchId:any;
    laundryItemId?:any;
    issuedQty:any;
    laundryIssuedId:any;
   // totalQty:number;
}


export abstract class LaundryIssuedData {
  status: string;
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<LaundryIssued[]>;
    abstract getById(url: string): Observable<LaundryIssued>;
    abstract create(url: string, data: LaundryIssued): Observable<LaundryIssued>;
    abstract update(url: string, data: LaundryIssued): Observable<LaundryIssued>;
    abstract delete(url: string): Observable<any>;
    abstract listDetail(url:string):Observable<LaundryIssuedDetail[]>;
    abstract createDetail(url:string,data:LaundryIssuedDetail[]):Observable<any>;
    abstract deleteDetail(url:string):Observable<any>;
   abstract updateDetail(url:string,data:LaundryIssuedDetail[]):Observable<any>;
   abstract frontList(url:string):Observable<FrontList[]>;
   abstract quickList(url:string):Observable<QuickList[]>;
  

}
